import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import IconTick from '@/assets/icons/icon-tick.svg?react';
import { Link } from 'react-router-dom';

interface ListItemDropdownProps {
  className: string;
  text: string;
  shortcut: string;
  selection: boolean;
  allowSelectionToggle: boolean;
  handlerClick: (event: React.MouseEvent<HTMLDivElement | HTMLAnchorElement, MouseEvent>) => void;
  href?: string;
  as?: 'a' | 'div';
}

export const ListItemDropdown: React.FC<ListItemDropdownProps> = ({
  text = 'String value',
  shortcut = '⌘K->T',
  className,
  selection = false,
  allowSelectionToggle = true,
  handlerClick,
  href = '#',
  as = 'div',
}) => {
  const [isSelected, setIsSelected] = useState(selection);

  const handleClickLocal = () => {
    if (allowSelectionToggle) {
      setIsSelected((prevSelection) => !prevSelection);
    }
  };

  useEffect(() => {
    setIsSelected(selection);
  }, [selection]);

  const commonClasses = clsx(
    'p-2 flex items-center justify-between text-button-sm h-8 w-full rounded bg-neutral-0 hover:bg-neutral-100 transition-all',
    {
      'text-neutral-500': !isSelected,
      'text-indigo-500': isSelected,
    },
    className,
  );

  const content = (
    <>
      {text && (
        <p
          className={clsx('text-button-sm', {
            'text-neutral-500': !isSelected,
            'text-indigo-500': isSelected,
          })}
        >
          {text}
        </p>
      )}
      {shortcut && <p className="text-button-xs text-neutral-400">{shortcut}</p>}
      {isSelected && <IconTick className="h-4 min-h-4 w-4 min-w-4 text-indigo-500" />}
    </>
  );

  if (as === 'a') {
    return (
      <Link
        to={href}
        className={commonClasses}
        onClick={(e) => {
          handleClickLocal();
          handlerClick(e);
        }}
      >
        {content}
      </Link>
    );
  }

  return (
    <div
      className={commonClasses}
      onClick={(e) => {
        handleClickLocal();
        handlerClick(e);
      }}
    >
      {content}
    </div>
  );
};
